import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {OptimizationCardScratchpadState} from '../../scratchpad/optimizationCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';
import {
  OptimizeAcrossName,
  OptimizeAcrossValue,
} from 'common/src/modules/optimization/optimization.types';
import getMatchingEnumValue from 'common/src/utils/typescriptUtils/getMatchingEnumValue';

const setOptimizeAcrossInputSchema = z.object({
  optimizeAcross: z
    .nativeEnum(OptimizeAcrossName)
    .describe('The optimization grouping level (Campaign, Placement, or AdSet)'),
});

export default function setOptimizeAcrossTool() {
  async function execute(
    params: ToolExecuteParams<typeof setOptimizeAcrossInputSchema, OptimizationCardScratchpadState>,
  ) {
    const {optimizeAcross: optimizeAcrossName} = params.input;
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<OptimizationCardScratchpadState>(
      agentScratchpad,
      NodeType.GENERAL_OPTIMIZATION,
    );

    const optimizeAcrossValue =
      getMatchingEnumValue(OptimizeAcrossName, OptimizeAcrossValue, optimizeAcrossName) ||
      OptimizeAcrossValue.Campaign;

    validatedScratchpad.card.configuration = {
      ...validatedScratchpad.card.configuration,
      optimizeGroup: optimizeAcrossValue,
    };

    return toolResult(`Optimize across set to ${optimizeAcrossName}`);
  }

  return tool<typeof setOptimizeAcrossInputSchema, OptimizationCardScratchpadState>({
    name: V2CardAgentToolName.SetOptimizeAcross,
    displayName: 'Setting optimize across',
    description: 'Set the optimization grouping level (Campaign, Placement, or AdSet).',
    inputSchema: setOptimizeAcrossInputSchema,
    execute,
  });
}
